import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { IconPanel } from '../../../../icon-panel/icon-panel';

export const ToolStartedPanel = () => {
  const { t } = useTranslation();

  return (
    <Component>
      <IconPanel
        header={{ icon: { icon: ['fad', 'arrows-maximize'], opacity: '50%', size: '8x' } }}
        responsiveness={{ compressed: false }}
      >
        {{
          title: t('initial.title', { ns: 'skyviewScale' }),
          info: t('initial.text', { ns: 'skyviewScale' }),
        }}
      </IconPanel>
    </Component>
  );
};

const Component = styled.div`
  height: 100%;
  padding: 1em;
`;
